export class StatusRegra {

    id: string;
    name: string;

    public static get ENQUADRADA() {
        return {id: 'ENQUADRADA', name: 'Enquadrada'};
    }

    public static get DESENQUADRADA() {
        return {id: 'DESENQUADRADA', name: 'Desenquadrada'};
    }

    public static get getStatusProcessamento() {
        return [
            this.ENQUADRADA,
            this.DESENQUADRADA
        ];
    }
}
